import { Button, Modal } from "antd";
import React from "react";
import { svg } from "../../../../Assets/svg";
import { useSearchParams } from "react-router-dom";
import { CreateQuotationStepsEnum } from "../quotationTypes";
import { useAppSelector } from "../../../../store";
import { selectQuotationDetails } from "../quotationSlice";

interface Props {
  open: boolean;
  onClose: () => void;
  showServiceAction?: boolean;
}

const NoItemsAddedModal: React.FC<Props> = ({
  open,
  onClose,
  showServiceAction = true,
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const quotationDetails = useAppSelector(selectQuotationDetails);
  return (
    <Modal
      open={open}
      centered
      width={"33.75rem"}
      footer={null}
      onCancel={onClose}
      closeIcon={svg?.closeIcon}
      title={
        <div className="text-center fs-4 fw-bolder lh-m">
          {"Please add Products/Services"}
        </div>
      }
      className="custom-modal"
    >
      {" "}
      <div className="d-flex flex-column gap-3 align-items-center">
        <p className="fs-6 text-center">
          {
            "You cannot create a quote without adding products or services. Please add at least one product or service to continue."
          }
        </p>
        <div className="d-flex justify-content-center gap-3">
          <Button
            onClick={() => {
              const currentId = searchParams.get("quotationId");
              const mode = searchParams.get("mode");
              const firstCat = quotationDetails?.categories_snapshot?.[0];
              const firstCatId = firstCat ? firstCat._id : null;

              const step = firstCatId
                ? `${firstCatId}__${CreateQuotationStepsEnum.PRODUCTS}`
                : CreateQuotationStepsEnum.STORAGE_TYPES;

              const params: any = {
                step,
                quotationId: currentId,
              };
              if (mode) params.mode = mode;
              setSearchParams(params);
              onClose();
            }}
            className={`btn btn-lg h-auto px-5 btn-primary`}
          >
            Add Products
          </Button>
          {showServiceAction && (
            <Button
              onClick={() => {
                const currentId = searchParams.get("quotationId");
                const mode = searchParams.get("mode");
                const params: any = {
                  step: CreateQuotationStepsEnum.SERVICES,
                  quotationId: currentId,
                };
                if (mode) params.mode = mode;
                setSearchParams(params);
                onClose();
              }}
              className={`btn btn-lg h-auto px-5 btn-primary`}
            >
              Add Services
            </Button>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default NoItemsAddedModal;
